import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import { Port3State, Port3Params, Port3ApiResponse } from "./Port3Type";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

export const fetchAsyncPort3Info: any = createAsyncThunk<
  Port3ApiResponse,
  Port3Params
>("port3/get", async () => {
  const response = await axiosSettings.get("api-admin/port3");
  return response.data;
});

const initialState: Port3State = {
  port3Status: null,
  updatedTime: "",
  loading: false,
  error: null,
};

const Port3InfoSlice = createSlice({
  name: "port3Info",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncPort3Info.fulfilled, (state, action) => {
      if (action.payload.status === "Success") {
        state.port3Status = action.payload.data.result;
        state.updatedTime = GetTime();
        state.error = "";
      } else {
        state.error = action.payload.status;
        return;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncPort3Info.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncPort3Info.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.status;
    });
  },
});

export const Port3Status = (state: RootState) => state.Port3Info.port3Status;
export const Port3Error = (state: RootState) => state.Port3Info.error;
export const Port3Loading = (state: RootState) => state.Port3Info.loading;
export const Port3UpdatedTime = (state: RootState) =>
  state.Port3Info.updatedTime;
export default Port3InfoSlice.reducer;
